var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 87.3394 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo.svg",
    clipPath: "url(#clip0_0_8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.5306 15.2847H18.5797V27.7364H24.5306V15.2847Z",
    fill: "var(--fill-0, #0D6CF9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.225774 13.4842V8.43342H13.9778V27.2363H8.37698V21.6354H0.225774V16.5346H8.37698V13.4842H0.225774Z",
    fill: "var(--fill-0, #0D6CF9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.931 22.536V17.1353H56.6848V22.536H30.931Z",
    fill: "var(--fill-0, #0D6CF9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.4318 5.3834V0.33264H52.1843V5.3834H48.6337V6.43355L52.6844 10.4842L48.6337 14.5347L43.783 8.93393L38.9824 14.5347L34.9317 10.4842L39.0323 6.43355V5.3834H35.4318Z",
    fill: "var(--fill-0, #0D6CF9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M60.4854 27.1862V11.4339H74.1373V16.5347H66.0862V22.0855H74.1373V27.1862H60.4854Z",
    fill: "var(--fill-0, #0D6CF9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M82.7885 10.9345H77.1875V27.1369H82.7885V21.5861H87.3392V17.0354H82.7885V10.9345Z",
    fill: "var(--fill-0, #0D6CF9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M20.9973 8.87066C21.2874 8.28289 22.1255 8.28289 22.4156 8.87066L22.6835 9.41344C22.7987 9.64685 23.0214 9.80863 23.279 9.84606L23.878 9.93312C24.5266 10.0274 24.7856 10.8245 24.3163 11.282L23.8828 11.7045C23.6964 11.8862 23.6114 12.148 23.6554 12.4045L23.7577 13.0011C23.8685 13.6471 23.1904 14.1398 22.6102 13.8347L22.0745 13.5531C21.8441 13.432 21.5688 13.432 21.3385 13.5531L20.8027 13.8347C20.2225 14.1398 19.5444 13.6471 19.6553 13.0011L19.7576 12.4045C19.8016 12.148 19.7165 11.8862 19.5301 11.7045L19.0967 11.282C18.6273 10.8245 18.8863 10.0274 19.535 9.93312L20.134 9.84606C20.3916 9.80863 20.6142 9.64685 20.7294 9.41344L20.9973 8.87066Z",
    fill: "var(--fill-0, #0D6CF9)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87.3394,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ce86649359687995454346d156705895.svg";
export { ForwardRef as ReactComponent };